module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dof-stepper weex-ct weex-div",
    attrs: {
      "weex-type": "div"
    }
  }, [_c('div', {
    staticClass: "stepper-minus weex-ct weex-div",
    attrs: {
      "aria-label": "减数",
      "accessible": true,
      "weex-type": "div",
      "data-evt-click": ""
    },
    on: {
      "click": _vm.$stopOuterA,
      "weex$tap": function($event) {
        $event.stopPropagation();
        return _vm.minusClicked($event)
      }
    }
  }, [_c('p', {
    staticClass: "stepper-icon weex-el weex-text",
    style: ({
      color: _vm.isLess ? '#cccccc' : '#616C73'
    }),
    attrs: {
      "weex-type": "text"
    }
  }, [_vm._v("-")])]), _vm._v(" "), _c('input', {
    staticClass: "stepper-input",
    style: (_vm._px2rem(_vm.disableStyle, 75)),
    attrs: {
      "type": "number",
      "disabled": _vm.disabled || _vm.readOnly,
      "data-evt-input": "",
      "data-evt-blur": ""
    },
    domProps: {
      "value": _vm.valueString
    },
    nativeOn: {
      "input": function($event) {
        $event.stopPropagation();
        return _vm.onInput($event)
      },
      "blur": function($event) {
        $event.stopPropagation();
        return _vm.onBlur($event)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "stepper-plus weex-ct weex-div",
    attrs: {
      "aria-label": "加数",
      "accessible": true,
      "weex-type": "div",
      "data-evt-click": ""
    },
    on: {
      "click": _vm.$stopOuterA,
      "weex$tap": function($event) {
        $event.stopPropagation();
        return _vm.plusClicked($event)
      }
    }
  }, [_c('p', {
    staticClass: "stepper-icon weex-el weex-text",
    style: ({
      color: _vm.isOver ? '#cccccc' : '#616C73'
    }),
    attrs: {
      "weex-type": "text"
    }
  }, [_vm._v("+")])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-4886894c", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4886894c","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./packages/dof-stepper/index.vue
// module id = 615
// module chunks = 0 1